var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _g, _rect, _circle6, _rect2, _circle7, _circle8, _circle9, _path, _rect3, _rect4, _circle0, _circle1, _path2, _rect5, _rect6, _line, _rect7, _rect8, _path3, _line2, _g2, _g3, _g4, _path4, _path5, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFeatureSigning = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F4FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFC658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ribbon",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FBB024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B06A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hdr",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B4CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A79F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plat",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5A82F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B4CC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "platRim",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#233F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16265A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ds",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 7,
    stdDeviation: 9,
    floodColor: "#141C3A",
    floodOpacity: 0.22
  })), /*#__PURE__*/React.createElement("filter", {
    id: "dsm",
    x: "-60%",
    y: "-60%",
    width: "220%",
    height: "220%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 5,
    floodColor: "#141C3A",
    floodOpacity: 0.2
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 66,
    r: 4,
    fill: "#FBB024",
    opacity: 0.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 300,
    r: 4,
    fill: "#FFFFFF",
    opacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 96,
    r: 3.5,
    fill: "#7FCACD",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 250,
    r: 3,
    fill: "#FFFFFF",
    opacity: 0.35
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 58,
    r: 7,
    fill: "none",
    stroke: "#FBB024",
    strokeWidth: 2.4,
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 44,
    width: 208,
    height: 254,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 40,
    width: 208,
    height: 254,
    rx: 14,
    fill: "url(#card)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 56,
    width: 172,
    height: 26,
    rx: 7,
    fill: "url(#hdr)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 151,
    cy: 69,
    r: 7,
    fill: "#FFFFFF",
    opacity: 0.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 65,
    width: 54,
    height: 7,
    rx: 3.5,
    fill: "#FFFFFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 294,
    cy: 69,
    r: 4.5,
    fill: "#FBB024"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 106,
    r: 12,
    fill: "#3A68DF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 102.64,
    r: 4.08,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 141.56 113.92 a 7.4399999999999995 6.6000000000000005 0 0 1 14.879999999999999 0",
    fill: "#FFFFFF",
    opacity: 0.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 100,
    width: 86,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 112,
    width: 56,
    height: 5,
    rx: 2.5,
    fill: "#E4E7F2"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 138,
    r: 12,
    fill: "#43979B"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 149,
    cy: 134.64,
    r: 4.08,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 141.56 145.92 a 7.4399999999999995 6.6000000000000005 0 0 1 14.879999999999999 0",
    fill: "#FFFFFF",
    opacity: 0.95
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 132,
    width: 86,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 144,
    width: 56,
    height: 5,
    rx: 2.5,
    fill: "#E4E7F2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 136,
    y1: 164,
    x2: 308,
    y2: 164,
    stroke: "#EAEDF6",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 190,
    width: 172,
    height: 62,
    rx: 9,
    fill: "#F5F7FD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 204,
    width: 46,
    height: 6,
    rx: 3,
    fill: "#C3CADE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 152 234 q 8 -22 16 -6 q 6 14 13 -3 q 6 -14 13 3 q 4 10 12 -4",
    fill: "none",
    stroke: "#20305B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 240,
    x2: 248,
    y2: 240,
    stroke: "#C3CADE",
    strokeWidth: 1.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#dsm)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 295 257 L 288 281 L 298 276 L 304 285 L 304 257 Z",
    fill: "url(#ribbon)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 309 257 L 316 281 L 306 276 L 300 285 L 300 257 Z",
    fill: "#C67A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.64 254.00 L322.28 259.44 L317.28 262.82 L316.85 268.85 L310.82 269.28 L307.44 274.28 L302.00 271.64 L296.56 274.28 L293.18 269.28 L287.15 268.85 L286.72 262.82 L281.72 259.44 L284.36 254.00 L281.72 248.56 L286.72 245.18 L287.15 239.15 L293.18 238.72 L296.56 233.72 L302.00 236.36 L307.44 233.72 L310.82 238.72 L316.85 239.15 L317.28 245.18 L322.28 248.56 Z",
    fill: "url(#gold)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 254,
    r: 13.860000000000001,
    fill: "#FBB024",
    stroke: "#FFC658",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 294 254 l 5 5.5 l 10 -11",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(208 232) rotate(-33)",
    filter: "url(#dsm)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 15 -5 L 15 5 Z",
    fill: "#FBB024"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: -5.5,
    width: 8,
    height: 11,
    rx: 1.5,
    fill: "#C67A00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: -6,
    width: 46,
    height: 12,
    rx: 5,
    fill: "#20305B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: -6,
    width: 14,
    height: 12,
    rx: 5,
    fill: "#3A68DF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: -6,
    width: 3,
    height: 12,
    fill: "#3B4664"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ds)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 212,
    width: 132,
    height: 74,
    rx: 14,
    fill: "#C9D2EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 208,
    width: 132,
    height: 74,
    rx: 14,
    fill: "url(#card)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 72 225 l 16.4 6.800000000000001 v 10 c 0 12.4 -10 18 -16.4 20.4 c -6.4 -2.4 -16.4 -8 -16.4 -20.4 v -10 Z",
    fill: "#43979B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 64 245 l 5 5.5 l 10 -11",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 232,
    width: 60,
    height: 7,
    rx: 3.5,
    fill: "#C3CADE"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 246,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#E4E7F2"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 258,
    width: 34,
    height: 6,
    rx: 3,
    fill: "#E9F6EE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 258,
    width: 18,
    height: 6,
    rx: 3,
    fill: "#4BB970"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFeatureSigning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/feature_signing.1110df7073bd5a93930e21c04e568e72.svg";